import TreatmentAPI from '@/app/apis/main/treatment/treatment-api.js';

export default {
	/**
	 * @returns {object} treatment list
	 */
	async getTreatments(petId, treatmentDetails) {
		return TreatmentAPI.getTreatments(petId, treatmentDetails);
	},

	/**
	 * @param {*} treatmentDetail - Contains Bundle ID, Date and Pet ID
	 * @param petId - Pet's ID
	 */
	async postTreatments(petId, treatmentDetail) {
		return TreatmentAPI.postTreatments(petId, treatmentDetail);
	},

	/**
	 * @return {object} treatment details
	 * @param {*} treatmentId - Id of chosen treatment
	 * @param dateApplied - Date when the Treatment was applied
	 */
	async putTreatment(treatmentId, dateApplied) {
		return TreatmentAPI.putTreatment(treatmentId, dateApplied);
	},

	/**
	 * @param {*} treatmentId
	 */
	async deleteTreatment(treatmentId) {
		return TreatmentAPI.deleteTreatment(treatmentId);
	},

	/**
	 * @param {*} bundleOptions
	 * @return {object} bundles
	 * */
	async getBundles(bundleOptions) {
		return TreatmentAPI.getBundles(bundleOptions);
	},

	/**
	 * @param {*} productType
	 * @return {object} brands
	 * */
	async getBrands(productType) {
		return TreatmentAPI.getBrands(productType);
	},

	/**
	 * @param {*} petId 
	 * @return {object} teatment overdue count
	 * */
	async getTreatmentOverdueCount(petId) {
		return TreatmentAPI.getTreatmentOverdueCount(petId);
    },
    
    /**
	 * @param {*} treatmentScheduleId
	 * @return {object} schedule treatment data
	 * */
	async getTreatmentSchedule(treatmentScheduleId) {
		return TreatmentAPI.getTreatmentSchedule(treatmentScheduleId);
    }
};